import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

import { ZatcaService } from '@teem/services/zatca.service';
import { LoaderService } from '@teem/app/core/services/loader.service';
import { messages as i18n } from '@teem/constants/messages';

@Component({
    selector: 'app-otp-modal',
    templateUrl: './otp-modal.component.html',
    styleUrls: ['./otp-modal.component.scss']
})
export class OtpModalComponent {
	@Input() type: 'compliance' | 'renew';
	otpForm: FormGroup;
	submitted: boolean = false;

	constructor(
		public activeModal: NgbActiveModal,
		private fb: FormBuilder,
		private zatcaService: ZatcaService, 
		private loaderService: LoaderService
	) {
		this.otpForm = this.fb.group({
			0: ['', [Validators.required, Validators.pattern(/^\d$/)]],
			1: ['', [Validators.required, Validators.pattern(/^\d$/)]],
			2: ['', [Validators.required, Validators.pattern(/^\d$/)]],
			3: ['', [Validators.required, Validators.pattern(/^\d$/)]],
			4: ['', [Validators.required, Validators.pattern(/^\d$/)]],
			5: ['', [Validators.required, Validators.pattern(/^\d$/)]],
		});
	}

	get otpControls(): FormControl[] {
		return Object.keys(this.otpForm.controls).map(
			key => this.otpForm.get(key) as FormControl
		);
	}

	focusNext(event: Event, index: number): void {
		const input = event.target as HTMLInputElement;
		// keep only one digit
		input.value = input.value.replace(/\D/g, '').slice(0, 1);
		if (input.value && input.nextElementSibling) {
			(input.nextElementSibling as HTMLElement).focus();
		}
		// if (input.value && index < this.otpControls.length - 1) {
		// 	const nextInput = document.querySelectorAll<HTMLInputElement>('.otp-input')[index + 1];
		// 	nextInput?.focus();
		// }
	}

	focusPrevious(event: KeyboardEvent, index: number) {
		const input = event.target as HTMLInputElement;
		if (event.key === 'Backspace' && !input.value) {
			const prev = input.previousElementSibling as HTMLElement;
			if (prev) {
				prev.focus();
			}
		}
	}

	submit(): void {
		const otp = Object.values(this.otpForm.value).join('');
		if (this.otpForm.valid && otp) {
			let fd = { otp: otp, type: this.type };
			this.loaderService.startLoading();
			this.zatcaService.requestingComplianceCertificate(fd).subscribe(
				(res: any) => {
					this.activeModal.close(res?.certificate);
					this.submitted = false;
					this.loaderService.stopLoading();
					Swal.fire(i18n.done, i18n.zatca.certificate_generated_successfully, 'success');
				},
				(err) => {
					this.loaderService.stopLoading();
					Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
				} 
			);
		}
	}

	close() {
		// this.dialogRef.close(null);
	}

}